module.exports = __webpack_public_path__ + "img/platform.5a464126.png";